import type { CSSProperties, ReactNode } from "react";

export function StatTile({
  label,
  value,
  meta,
  tone,
}: {
  label: string;
  value: ReactNode;
  meta?: ReactNode;
  tone?: string;
}) {
  const style = tone ? ({ "--tone": tone } as CSSProperties) : undefined;
  return (
    <div className="stat rise" style={style}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {meta ? <div className="stat-meta">{meta}</div> : null}
    </div>
  );
}
